import axios from "axios";
import { QueryResult, useQuery } from "react-query";

import { BusinessRole, TireMaterialConfig } from "../types/domain";

const getRecycleMaterials = (businessRoles?: BusinessRole[]) => {
  const allowedRoles: string | undefined = businessRoles
    ? businessRoles.join(",")
    : undefined;

  return axios
    .get<TireMaterialConfig[]>("materials/recycleMaterials", {
      params: { allowedRoles },
    })
    .then((res) => res.data);
};

const useRecycleMaterials = (businessRoles?: BusinessRole[]) => {
  const { data, ...queryResult } = useQuery(
    ["tires", businessRoles],
    () => getRecycleMaterials(businessRoles),
    {
      staleTime: Infinity,
    }
  );

  return {
    data,
    ...queryResult,
  } as QueryResult<TireMaterialConfig[]>;
};

export default useRecycleMaterials;
